export default __webpack_public_path__ + "static/media/LogoBlik.eb9a1a9d.png";